import EditTemplatePage from "./edit-template.container";
export default EditTemplatePage;
